<article class="dialog">
  <button class="dialog__close" (click)="dismiss()">
    <svg-icon
      key="times"
      fontSize="2em"
    ></svg-icon>
  </button>

  <header class="dialog__header">
    <svg-icon
      class="dialog__icon"
      [key]="iconKey"
      fontSize="2rem"
    ></svg-icon>
    <h1 class="dialog__title">{{ title | transloco }}</h1>
  </header>

  <div class="dialog__body">
    <p>{{ description | transloco }}</p>
  </div>

  <footer class="dialog__footer">
    <aero-button
      (click)="cancel()"
      label="{{ dismissLabel | transloco }}"
      [aeroStyle]="cancelButtonStyle"
    >
    </aero-button>
    <aero-button
      (click)="confirm()"
      label="{{ confirmLabel | transloco }}"
    >
    </aero-button>
  </footer>
</article>
